module.exports = __webpack_public_path__ + "static/media/camera_icon.a42106b5.svg";